import type { ReactNode } from "react";
import type { PasswordRule } from "./passwordPolicy";

/**
 * Renders the live password-policy checklist, one row per rule with a
 * pass/fail marker. Driven by `evaluatePasswordRules` so it stays in lockstep
 * with the submit-gate check.
 */
export function PasswordChecklist({ rules }: { rules: PasswordRule[] }): ReactNode {
  return (
    <ul className="mt-3 space-y-1" aria-label="Password requirements">
      {rules.map((rule) => (
        <li
          key={rule.id}
          className={
            rule.ok
              ? "text-forest flex items-center gap-2"
              : "text-slate-teal flex items-center gap-2"
          }
        >
          <span aria-hidden className="inline-block w-4 text-center font-semibold">
            {rule.ok ? "✓" : "•"}
          </span>
          <span className="text-xs">{rule.label}</span>
        </li>
      ))}
    </ul>
  );
}
